import service from 'utils/service';
import type { PincodeRow } from 'views/orders/create-order/components/NewPickupAddressDialog';

export type RegistrationPincodeRow = PincodeRow;

export type CustomerSignupBody = {
  NAME: string;
  MOBILE_NO: string;
  EMAIL_ID: string;
  PASSWORD: string;
  ADDRESS: string;
  FIRM_NAME: string;
  CITY: string;
  PINCODE_ID: number | string;
  STATE_ID: number | string;
};

function isApiOk(response: any): boolean {
  return response?.code === 200 || response?.statusCode === 200 || response?.success === true;
}

export async function fetchRegistrationPincodes(): Promise<RegistrationPincodeRow[]> {
  const response: any = await service.makeAPICall({
    methodName: service.Methods.POST,
    apiUrl: service.API_URL.pincode.commonListing,
    body: {}
  });
  if (!isApiOk(response)) return [];
  const rows = response?.data;
  return Array.isArray(rows) ? rows : [];
}

export async function sendRegistrationOtp(email: string, name: string): Promise<void> {
  const response: any = await service.makeAPICall({
    methodName: service.Methods.POST,
    apiUrl: service.API_URL.auth.sendRegistrationEmail,
    body: { EMAIL_ID: email, NAME: name }
  });
  if (!isApiOk(response)) {
    throw new Error(
      typeof response?.message === 'string' ? response.message : 'Unable to send registration OTP. Please try again.'
    );
  }
}

export async function verifyRegistrationOtp(email: string, otp: string): Promise<void> {
  const response: any = await service.makeAPICall({
    methodName: service.Methods.POST,
    apiUrl: service.API_URL.auth.verifyRegistrationOTP,
    body: { EMAIL_ID: email, OTP: otp }
  });
  if (!isApiOk(response)) {
    throw new Error(typeof response?.message === 'string' ? response.message : 'Invalid OTP. Please try again.');
  }
}

export async function createCustomerAccount(body: CustomerSignupBody): Promise<void> {
  const response: any = await service.makeAPICall({
    methodName: service.Methods.POST,
    apiUrl: service.API_URL.auth.signup,
    body
  });
  if (!isApiOk(response)) {
    throw new Error(
      typeof response?.message === 'string' ? response.message : 'Unable to create account. Please try again.'
    );
  }
}

export function buildCustomerSignupBody(params: {
  fullName: string;
  mobileNo: string;
  email: string;
  password: string;
  firmName: string;
  address: string;
  pincodeId: number;
  city: string;
  stateId: number | string;
}): CustomerSignupBody {
  return {
    NAME: params.fullName.trim(),
    MOBILE_NO: params.mobileNo.trim(),
    EMAIL_ID: params.email.trim(),
    PASSWORD: params.password,
    ADDRESS: params.address.trim(),
    FIRM_NAME: params.firmName.trim(),
    CITY: params.city,
    PINCODE_ID: params.pincodeId,
    STATE_ID: params.stateId
  };
}
